import React from "react";
import { BiLogOut } from "react-icons/bi";
import { IoSearch, IoSettingsOutline } from "react-icons/io5";
import { TbGridDots } from "react-icons/tb";

const LoanOfficerSidebar = () => {
  return (
    <div className="bg-[#3A9391] rounded-[16px] fixed top-[100px] h-[86vh] p-[8px] flex flex-col justify-between">
      <div className="flex gap-y-[10px] flex-col">
        <div className="h-[56px] w-[56px] bg-white rounded-[8px] text-[#3A9391] flex justify-center items-center cursor-pointer">
          <TbGridDots className="h-6 w-6" />
        </div>
        <div className="h-[56px] w-[56px] bg-[#F8F8F81A] rounded-[8px] text-white flex justify-center items-center cursor-pointer">
          <IoSettingsOutline className="h-6 w-6" />
        </div>
        <div className="h-[56px] w-[56px] bg-[#F8F8F81A] rounded-[8px] text-white flex justify-center items-center cursor-pointer">
          <IoSearch className="h-6 w-6" />
        </div>
      </div>
      <div>
        <div className="h-[56px] w-[56px] bg-[#F8F8F81A] rounded-[8px] text-white flex justify-center items-center cursor-pointer">
          <BiLogOut className="h-6 w-6" />
        </div>
      </div>
    </div>
  );
};

export default LoanOfficerSidebar;
